import React from 'react';
import { v4 as uuidv4 } from 'uuid';

const WidgetCustomer = (props) => {
  const preText = props.state.prevMessage;
  const _prev = () => {
    props.actionProvider._categoryPrev(preText);
  };
  const _goHome = () => {
    props.actionProvider._home(-1);
  };
  const _my = () => {
    window.open('https://shop.aniplustv.com/mypage');
  };
  const _qna = () => {
    window.open('https://shop.aniplustv.com/mypage/qna');
    // const sessionKey = uuidv4();
    // props.actionProvider._selectQna('1 : 1 문의하기', sessionKey);
  };
  return (
    <>
      <div className="prev-chat-container">
        <div className="prev-contaner">
          <div className="prev" onClick={_my}>
            <img src="/img/chatbot/icon_prev.png" />
            마이쇼핑 바로가기
          </div>

          <div className="prev" onClick={_qna}>
            <img src="/img/chatbot/icon_qna.png" />
            1:1문의 남기기
          </div>
        </div>
      </div>
      <div className="prev-chat-container">
        <div className="prev-contaner">
          {preText === '' ||
          preText === undefined ||
          preText === null ? null : (
            <div onClick={_prev} className="prev">
              <img src="/img/chatbot/icon_prev.png" />
              이전 단계로 이동
            </div>
          )}

          <div onClick={_goHome} className="prev">
            <img src="/img/chatbot/icon_home.png" />
            처음으로
          </div>
        </div>
      </div>
    </>
  );
};

export default WidgetCustomer;
